import styled from 'styled-components';
import { SwitchMixin } from '../../mixins/components/SwitchMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledSwitch = /*#__PURE__*/styled('label').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['disabled', 'size'])
}).withConfig({
  displayName: "StyledSwitch",
  componentId: "c11n-8-111-1__sc-igsiw0-0"
})(["", ""], SwitchMixin);